module.exports = __webpack_public_path__ + "img/fiveYears.92ad4cc5.png";